import type {
  CollectGraphql,
  IncidentGraphql,
  RateCollectNpsInputGraphql,
} from '~/types/graphql-backend-types/gql-types'
import {
  COLLECTS_QUERY_SINGLE,
  RATE_COLLECT_NPS,
} from '~/queries/collects'
import { isObjectEmpty } from '~/utils/object'

export const useCollectStore = defineStore('collect', () => {
  const { query, mutate } = useGqlMikro()
  const collect = ref<CollectGraphql>({} as CollectGraphql)
  const collectLoading = ref<boolean>(false)
  const { isAdmin } = storeToRefs(useAuthStore())

  const incidents = computed(() => {
    if (isObjectEmpty(collect.value))
      return []
    return collect.value?.incidents?.collection as IncidentGraphql[] ?? []
  })

  const incidentsPenalty = computed(() => {
    let total = 0
    incidents.value.forEach((incident) => {
      if (incident)
        total += incident.penaltyAmount ? incident.penaltyAmount : 0
    })
    return total
  })

  const transportPrice = computed(() => {
    return collect.value?.transportPrice
  })

  async function loadSingleCollect(id: string) {
    if (!id)
      return

    collectLoading.value = true
    const { data, errors } = await query({
      query: COLLECTS_QUERY_SINGLE,
      variables: {
        pagination: {},
        filters: { ids: [id] },
        isAdmin: isAdmin.value,
      },
    })

    if (errors && errors.length > 0) {
      throw errors
    }

    collectLoading.value = false
    collect.value = JSON.parse(JSON.stringify(data.collects.collection[0]))
    collect.value.startsAt = new Date(collect.value.startsAt).toISOString()
    return collect.value
  }

  async function rateCollectNps(input: RateCollectNpsInputGraphql) {
    const { collects } = storeToRefs(useCollectsStore())

    const { data, errors } = await mutate({
      mutation: RATE_COLLECT_NPS,
      variables: { input },
    })

    if (errors && errors.length > 0) {
      throw errors
    }

    const cs = collects.value?.collection?.find(item => item?.id === input.collectId)
    if (cs) {
      cs.npsRating = data!.rateCollectNPS.npsRating
    }
    collect.value!.npsRating = data!.rateCollectNPS.npsRating

    return { data }
  }

  return {
    collect,
    collectLoading,
    incidents,
    incidentsPenalty,
    transportPrice,
    rateCollectNps,
    loadSingleCollect,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCollectStore, import.meta.hot))
}
